import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

function PdfViewer({ setPageHeader }) {
  setPageHeader("PDF Viewer");
  const urlCode = useSelector(state => state.urlCode);
  const { search } = useLocation();
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);

  const apiUrl = query.get("api") || '/fetchfilesingle';

  return (
    <div className="pdfHolder">

      <embed
        src={`${process.env.REACT_APP_API_ENDPOINT
          }${apiUrl}${search}&token=${localStorage.getItem("token")}&urlCode=${urlCode}#toolbar=0`}
        width="100%"
        height="100%"
        style={{ minHeight: "100vh" }}
      />
    </div>
  );
}

export default PdfViewer;
